<template>

    <div id="chat-list" class="chat-list widget">
        <div class="panel">
            <div class="panel-heading">
                <h2>Think Tank Chat <i class="clippie fa fa-info-circle" v-tooltip="'Realtime instant messaging'"></i></h2>
                <div class="toggle-widget" @click="openChat()">
                    <i class="fa fa-plus"></i>
                </div>
            </div>
        </div>
    </div>

</template>


<script>

import DDP from 'ddp.js';

const uuid = require('uuid/v4');

export default {
    data() {
        return {
            ddpClient:null,
            unread: null,
            open:false,
            users:null
        }
    },

    mounted() {
        var self = this;

        // const options = {
        //     endpoint: window.chatWS,
        //     SocketConstructor: WebSocket
        // };
        // this.ddpClient = new DDP(options);

        // this.ddpClient.on("connected", () => {
        //     console.log("Connected");
        // });

        // let retryCount = 0;
        // let checkForToken = window.setInterval(function(){
        //     console.log(retryCount)
        //     if (retryCount > 10) {
        //         clearInterval(checkForToken);
        //     }
        //     if (localStorage.rocket_token) {
        //         self.subscribe();
        //         self.getActiveUsers();
        //         clearInterval(checkForToken);
        //     }
        //     retryCount++;
        // },1000);


    },
    methods: {
        openChat(userName) {
            let url = window.chatUrl + '/home?user_id=' + localStorage.rocket_id + '&token=' + localStorage.rocket_token + '&origin=portal';
            
            if (userName) { url += '&dm=' + userName }

            let chatWindow = window.open(url, '_blank', 'location=0,height=570,width=960,scrollbars=yes,status=0');
        },
        subscribe() {
            var self = this;
            const loginParams = {resume: localStorage.rocket_token };
            const login = this.ddpClient.method("login", [loginParams]);        

            self.ddpClient.method('subscriptions/get', [], uuid());
            self.ddpClient.sub('stream-room-messages', ['GENERAL', false], uuid());
            self.ddpClient.sub('stream-notify-user', [localStorage.rocket_id + '/notification', false], uuid());

            self.ddpClient.on("result", function(message) {
                if (Array.isArray(message.result) && (message.result[0].unread > -1)) {
                    let unread = message.result.map(function(m) {
                        return m.unread;
                    }).reduce(function(a, b) {
                        return a + b;
                    });
                    self.unread += unread;
                }               
            });

            self.ddpClient.on('changed', function (msg) {

                if (msg.fields.args[0].payload && msg.fields.args[0].payload.type === 'd' || msg.fields.args[0].payload.type === 'c') {
                    self.unread++;
                }
            });     

        },

    }
}
</script>


<style lang="scss" scoped>


</style>


// WEBPACK FOOTER //
// RocketChat.vue?05bedd44